export const ipMoodle = "138.68.226.91";
export const baseURL = "https://udalba.tipddy.cl/";
// export const tipddytoken = "122c8d73318e7ae3c25261962bea48c1";
// export const tipddytoken = "6efdf3eb77bc8beca386c774fab608aa";
//export const tipddytoken = "4f7ded3dd876db415ad9e11406e8e78b"; // tuclase
export const tipddytoken = "769afe1087969aacc3cd4d434a32b351"; // esta estpa generado a nombre de agu quiroz
export const moodleURL = `${baseURL}webservice/rest/server.php?wstoken=`;
export const iappUrl = "https://tipddy-rnu.iapp.cl/api/rnu";

export const API = {
  dev: "http://localhost:3000/",
  prod: "https://alumnos.tuclase.cl",
};
